import React from "react";
import "./style.css"
import quranLogo from "../assets/quran.png"

export default function Department({ name, status, onClickFn }) {
    return (
        <div className="department" onClick={onClickFn}>
            <img src={quranLogo} alt="Quran Logo" />
            <h2>{name}</h2>

            <div className="status">
                {status}
            </div>
        </div>
    );
}
